"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _UserProfileStaticComponent = _interopRequireDefault(require("./UserProfileStaticComponent"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
require("./ProfileFormComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var classes = (0, _cssClassesHelper.getBEMClasses)('retail-profile-form');
var ProfileFormComponent = function ProfileFormComponent(props) {
  var showUsernameField = !props.useEmailAsUsername;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('container')
  }, /*#__PURE__*/_react["default"].createElement(_UserProfileStaticComponent["default"], {
    showUsernameField: showUsernameField,
    userInfo: {
      email: props.formObj.email,
      username: props.formObj.username
    }
  })));
};
var _default = exports["default"] = ProfileFormComponent;